module.exports = __webpack_public_path__ + "media/images/avatar/development/nannies/20-6180a935188d1d2deb48010a292c85a7.jpg";